import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';

/**
 * Header component
 */
export default class DrawingVector extends withIntersectionObserver(Base, {
  threshold: 1,
}) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'DrawingVector',
    refs: ['menuBtn'],
  };

  /**
   * Add class when element is in viewport
   * @param  {Array} entries
   * @returns {void}
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.$el.classList.add('in-view');
    }
  }
}
